<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <v-subheader class="pl-0">
          POS Products listing Limit
        </v-subheader>
        <v-slider
          v-model="posForm.posProductsLimit"
          max="100"
          min="5"
          :thumb-size="24"
          color="success"
          :error-messages="errors.getMessage('posProductsLimit')"
          thumb-label="always"
        />
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <v-subheader class="pl-0">
          Default Sale Discount Rate %
        </v-subheader>
        <v-slider
          v-model="posForm.defaultDiscountRate"
          max="100"
          :thumb-size="24"
          min="0"
          color="red"
          :error-messages="errors.getMessage('defaultDiscountRate')"
          thumb-label="always"
        />
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <v-subheader class="pl-0">
          Default Sale Tax Rate %
        </v-subheader>
        <v-slider
          v-model="posForm.defaultTaxRate"
          max="100"
          min="0"
          :thumb-size="24"
          color="warning"
          :error-messages="errors.getMessage('defaultTaxRate')"
          thumb-label="always"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          v-model="posForm.printerWidth"
          label="Printer Width"
          :error-messages="errors.getMessage('printerWidth')"
        />
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          v-model="posForm.printerHight"
          label="Recipent Height"
          :error-messages="errors.getMessage('printerHight')"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-autocomplete
          v-model="posForm.productSkin"
          hide-details="auto"
          :items="skins"
          item-text="name"
          item-value="value"
          label="Product Icon skin"
          :error-messages="errors.getMessage('productSkin')"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          v-model="posForm.focusIntervel"
          label="Scanner autofocus intervel"
          messages="(1000 = 1 Sec)"
          :error-messages="errors.getMessage('focusIntervel')"
          type="number"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          v-model="posForm.scanningSensitivity"
          label="Scanning Sensitivity Delay "
          :error-messages="errors.getMessage('scanningSensitivity')"
          messages="(1000 = 1 Sec)"
          type="number"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          v-model="posForm.barcodeContainsDigits"
          label="Standard Barcode Contains Digits"
          :error-messages="errors.getMessage('barcodeContainsDigits')"
          messages="(12 default)"
          type="number"
        />
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <v-checkbox
          v-model="posForm.overSelling"
          label="Disable Item (at zero qty)"
        />
        <v-checkbox
          v-model="posForm.isTaxIncluded"
          label="Tax Included"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-checkbox
          v-model="posForm.productName"
          label="Show Product Name"
        />
        <v-checkbox
          v-model="posForm.stopDiscount"
          label="Stop Sale Discount"
        />
        <v-checkbox
          v-model="posForm.posAutoLoadProducts"
          label="Auto Load POS Products"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-btn
        class="info"
        @click="generalUpdate"
      >
        Update
      </v-btn>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      skins: [
        { name: "No Skin", value: "white" },
        { name: "Black", value: "secondary" },
        { name: "Yellow", value: "warning" },
        { name: "Blue", value: "info" },
        { name: "Lite Blue", value: "primary" },
        { name: "Green", value: "success" },
        { name: "Red", value: "error" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
      posForm: "configs/pos",
    }),
  },

  methods: {
    generalUpdate() {
      Event.$emit("updateConfigs", {
        path: "setting-pos-update",
        payload: this.posForm,
      });
    },
  },
};
</script>
